import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { SignUp } from "@/features/join/sign-up";
import { maskSearchFragment } from "@/features/shared/route-masking";

export const Route = createFileRoute("/(member)/(public)/join/sign-up")({
  component: SignUp,
  validateSearch: z.object({
    planKey: z.string().optional(),
    discountCode: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    checkoutId: z.string().optional(),
    addOns: commaListSchema,
    referId: z.string().optional(),
    referredBy: z.string().optional(),
    // First-touch attribution; `Join` reads these off the landing URL into analytics.
    utm_source: z.string().optional(),
    utm_medium: z.string().optional(),
    utm_campaign: z.string().optional(),
    ...maskSearchFragment,
  }),
});
